const getUpgradeData = (rootState, productType) => rootState.upgradeOptions[productType];

export default getUpgradeData;
